// extracted by mini-css-extract-plugin
export default {"container":"SunburstChart_container__gTaIL"};